export default [
  {
    path: "/403",
    name: "forbidden",
    component: () => import("@/shared/pages/noAccess.vue"),
    meta: {
      layout: "error",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("@/shared/pages/noAccess.vue"), // You can create a dedicated NotFound page
    meta: {
      layout: "error",
    },
  },
];
